import type * as React from 'react';

import { CollisionPriority } from '@dnd-kit/abstract';
import { useDroppable } from '@dnd-kit/react';

export const DealCardsList = ({ id, children }: { id: string; children: React.ReactNode }) => {
    const { ref } = useDroppable({
        id: `${id}-drop-area`,
        type: 'deal-list',
        accept: 'deal',
        data: { group: id },
        collisionPriority: CollisionPriority.Low,
    });

    return (
        <div
            ref={ref}
            data-deal-cards-list
            className="relative flex h-full min-h-0 flex-col gap-2 overflow-x-hidden overflow-y-auto rounded-[10px]"
        >
            {children}
        </div>
    );
};
